import { InjectionToken, inject } from '@angular/core';
import { LOCAL_STORAGE, SESSION_STORAGE } from '../browser';
import { EpdkFootprints, epdkFootprints } from './epdk-footprints';
import { Footprints } from './footprints';
import { FootprintsService } from './footprints.service';

export const FOOTPRINTS_SERVICE = new InjectionToken('Footprints service');

export const FOOTPRINTS_EPDK_SERVICE = new InjectionToken('Footprints EPDK service');

export function CreateFootprintsServiceInjectionToken<T extends Footprints<T>>(
  storageKey: string,
  config: T
): InjectionToken<FootprintsService<T>> {
  return new InjectionToken<FootprintsService<T>>('Footprints service', {
    providedIn: 'root',
    factory: () => new FootprintsService<T>(storageKey, config, inject(LOCAL_STORAGE), inject(SESSION_STORAGE))
  });
}

export function CreateFootprintsEpdkServiceInjectionToken<T extends Footprints<T>>(
  storageKey: string,
  config: T
): InjectionToken<FootprintsService<T & EpdkFootprints>> {
  return new InjectionToken<FootprintsService<T & EpdkFootprints>>('Footprints EPDK service', {
    providedIn: 'root',
    factory: () => new FootprintsService<T & EpdkFootprints>(
      storageKey, { ...epdkFootprints, ...config }, inject(LOCAL_STORAGE), inject(SESSION_STORAGE))
  });
}